<template>
  <div class="contain opt-unified">
    <!-- 상단 툴바: 검색 + 액션 (전체 폭, 한 줄) -->
    <div class="search_form opt-toolbar" ref="search_form">
      <el-form :inline="true" label-suffix=":" :size="size" @submit.native.prevent>
        <el-form-item :label="$t('옵션 그룹명')">
          <el-input
            v-model="groupSearch.smenuOptTpNm"
            @keyup.enter.native="loadGroups()"
            clearable
            style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('사용 가능 여부')">
          <combo
            :data="mainVue.code.useYn"
            :label="$t('전체')"
            :model="groupSearch.useYn"
            @change="groupSearch.useYn = $event"></combo>
        </el-form-item>
        <el-form-item class="toolbar-actions">
          <el-button :size="size" icon="el-icon-search" @click="loadGroups()">{{ $t('검색') }}</el-button>
          <el-button
            v-if="checkAuthActionAccess('SmenuOptForStoreAdd')"
            :size="size"
            type="primary"
            plain
            icon="el-icon-circle-plus-outline"
            @click="newGroup"
            >{{ $t('옵션 그룹 추가') }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-row :gutter="narrow ? 0 : 16">
      <!-- ─────────── 좌: 옵션그룹 목록 ─────────── -->
      <el-col :span="narrow ? 24 : 9">
        <el-table
          :height="tableHeight"
          ref="groupTable"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="groups"
          :size="size"
          v-loading="loadingGroups"
          :empty-text="$t('데이타 없음')"
          @row-click="onGroupRowClick">
          <el-table-column :label="$t('옵션 그룹명')" min-width="130" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.smenuOptTpNmLan || scope.row.smenuOptTpNm }}</span>
              <el-tag
                v-if="scope.row.masterOptTpCd"
                size="mini"
                type="success"
                effect="plain"
                style="margin-left: 4px"
                >{{ $t('공유') }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('선택 규칙')" min-width="96" align="center">
            <template slot-scope="scope">{{ formatRule(scope.row) }}</template>
          </el-table-column>
          <el-table-column :label="$t('옵션 수')" width="70" align="center">
            <template slot-scope="scope">{{ optCountMap[scope.row.smenuOptTpCd] || 0 }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('사용 가능 여부')"
            prop="useYn"
            width="90"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
          <el-table-column v-if="narrow" width="44" align="center">
            <template slot-scope="scope">
              <i
                class="el-icon-arrow-right drill-chevron"
                :class="{ active: scope.row.smenuOptTpCd === curGroupCd }"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-col>

      <!-- ─────────── 우: 상세 (그룹 폼 + 옵션 항목) ─────────── -->
      <!-- 데스크톱: 우측 컬럼 / 좁은 화면: 우측 슬라이드 패널 — 마크업은 한 곳, 래퍼만 반응형 전환 -->
      <el-col
        :span="narrow ? 24 : 15"
        class="detail-col"
        :class="{ 'detail-drawer': narrow, 'is-open': narrow && groupMode !== 'none' }">
        <el-card v-if="groupMode === 'none' && !narrow" shadow="never" class="empty-card">
          <div class="empty-hint">
            <i class="el-icon-back"></i>
            {{ $t('왼쪽에서 옵션 그룹을 선택하거나 "옵션 그룹 추가"를 눌러 시작하세요.') }}
          </div>
        </el-card>

        <el-card
          v-if="groupMode !== 'none'"
          shadow="never"
          v-loading="loadingDetail"
          :class="{ 'detail-scroll': !narrow }">
          <div slot="header" class="detail-header">
            <span class="detail-title">
              <el-button
                v-if="narrow"
                type="text"
                icon="el-icon-arrow-left"
                class="drawer-back"
                @click="closeDetailNarrow"
                >{{ $t('목록') }}</el-button
              >
              <b>{{ groupMode === 'new' ? $t('새 옵션 그룹') : groupForm.smenuOptTpNm || $t('옵션 그룹') }}</b>
              <el-tag v-if="groupForm.masterOptTpCd" size="mini" type="success" effect="plain">{{ $t('공유') }}</el-tag>
            </span>
            <span>
              <el-button
                v-if="checkAuthActionAccess('SmenuOptForStoreUp')"
                :size="size"
                type="primary"
                icon="el-icon-check"
                @click="saveGroup"
                >{{ $t('그룹 저장') }}</el-button
              >
              <el-button
                v-if="groupMode === 'view' && checkAuthActionAccess('SmenuOptForStoreDel')"
                :size="size"
                type="danger"
                plain
                icon="el-icon-delete"
                @click="delGroup"
                >{{ $t('그룹 삭제') }}</el-button
              >
            </span>
          </div>

          <!-- 그룹 기본 정보 -->
          <el-form
            :model="groupForm"
            label-width="120px"
            label-suffix=":"
            :size="size"
            class="group-form"
            @submit.native.prevent>
            <!-- 그룹명: 전체 폭 (다국어 조회 버튼 여유 확보) -->
            <el-form-item :label="$t('옵션 그룹명')" :error="groupFormError.smenuOptTpNm" required>
              <el-input v-model="groupForm.smenuOptTpNm" maxlength="50" clearable show-word-limit>
                <el-button v-if="lans.length > 1" slot="append" @click="openDict('group')" icon="el-icon-search">{{
                  $t('다국어 조회')
                }}</el-button>
              </el-input>
            </el-form-item>

            <el-form-item :label="$t('옵션 선택 구분')" :error="groupFormError['optTp.cd']" required>
              <code-combo
                :data="optTpCodes"
                :model="groupForm.optTp.cd"
                @change="groupForm.optTp = $event"></code-combo>
            </el-form-item>
            <el-form-item :label="$t('선택 수량')">
              <el-input-number v-model="groupForm.minCount" :min="0" :max="99" :controls="false" style="width: 92px" />
              <span style="margin: 0 10px">~</span>
              <el-input-number v-model="groupForm.maxCount" :min="0" :max="99" :controls="false" style="width: 92px" />
              <div class="field-hint">
                {{ $t('최소~최대 선택 개수. 0=제한 없음, 최소 1 이상이면 필수 선택. POS·QR 주문에 적용.') }}
              </div>
              <!--
                ★★ **배달앱 쪽 사실은 서버가 답한다** (OPTION-SELECT-COUNT-UNPUSHABLE ·
                OPTION-NAME-FANOUT-NOTICE). 상한은 **가장 좁은 동명 그룹**이 정하므로 사장님이
                자기 그룹만 봐서는 알 수 없고, 넘기면 배달앱이 **원자적으로 거절**한다.
                관측이 없으면 서버가 `null` 을 내리고 그때는 아무 말도 하지 않는다.
              -->
              <div v-if="deliveryCapNote" class="field-hint field-hint--delivery">{{ deliveryCapNote }}</div>
              <div v-if="deliveryOrdernOnlyNote" class="field-hint field-hint--delivery">
                {{ deliveryOrdernOnlyNote }}
              </div>
              <div v-for="n in deliveryFanoutNotes" :key="n" class="field-hint field-hint--delivery">{{ n }}</div>
              <!--
                ★ 다른 매장과 함께 쓰는 그룹임을 말한다 (`OPTION-CROSS-STORE-CONFLICT`).
                막지 않는다 — 막으면 평범한 단일 매장 토글이 상시 죽는다(§16.235②).
              -->
              <div v-for="n in deliverySharedStoreNotes" :key="n" class="field-hint field-hint--delivery">{{ n }}</div>
            </el-form-item>
            <el-row :gutter="16">
              <el-col :span="24" :lg="12">
                <el-form-item :label="$t('표시 순서')" :error="groupFormError.ord" required>
                  <el-input-number v-model="groupForm.ord" :min="1" :max="99" :controls="false" style="width: 92px" />
                </el-form-item>
              </el-col>
              <el-col :span="24" :lg="12">
                <el-form-item :label="$t('사용 가능 여부')" required>
                  <combo :data="mainVue.code.useYn" :model="groupForm.useYn" @change="groupForm.useYn = $event"></combo>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 다국어: 전체 폭 -->
            <el-form-item
              v-if="groupForm.smenuOptTpInfos && groupForm.smenuOptTpInfos.length > 0"
              :label="$t('다국어')">
              <el-tabs v-model="groupActiviTab">
                <el-tab-pane
                  v-for="(item, index) in groupForm.smenuOptTpInfos"
                  :key="item.lanTp.id"
                  :label="item.lanTp.nm"
                  :name="item.lanTp.id">
                  <el-form-item
                    label-width="0"
                    :error="groupFormError['smenuOptTpInfos[' + index + '].smenuOptTpInfoNm']">
                    <el-input
                      v-model="groupForm.smenuOptTpInfos[index].smenuOptTpInfoNm"
                      maxlength="50"
                      clearable
                      show-word-limit
                      :placeholder="item.lanTp.nm + ' ' + $t('옵션 그룹명')"></el-input>
                  </el-form-item>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </el-form>

          <!-- 옵션 항목 (그룹 저장 후) -->
          <div v-if="groupMode === 'view'" class="opt-section">
            <el-divider content-position="left">{{ $t('옵션 항목') }}</el-divider>

            <el-table
              :data="optRows"
              :size="size"
              class="opt-item-table"
              :empty-text="$t('옵션 없음 — 아래에서 추가하세요')">
              <el-table-column :label="$t('옵션명')" min-width="180">
                <template slot-scope="scope">
                  <!-- 단일 언어 매장: 인라인 편집. 다국어 매장: 언어별 이름 desync 방지 위해 [상세]에서만 수정 -->
                  <el-input v-if="lans.length <= 1" v-model="scope.row.smenuOptNm" :size="size" maxlength="50">
                    <el-tag v-if="scope.row.masterOptCd" slot="prepend" size="mini" type="success" effect="plain">{{
                      $t('공유')
                    }}</el-tag>
                  </el-input>
                  <span v-else>
                    <el-tag
                      v-if="scope.row.masterOptCd"
                      size="mini"
                      type="success"
                      effect="plain"
                      style="margin-right: 4px"
                      >{{ $t('공유') }}</el-tag
                    >
                    {{ scope.row.smenuOptNmLan || scope.row.smenuOptNm }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('단가')" width="130" align="right">
                <template slot-scope="scope">
                  <!-- 국제결제 매장은 언어별 단가라 인라인 수정 불가 → [상세]에서 편집 -->
                  <el-input-number
                    v-if="!internationalPayYn"
                    v-model="scope.row.price"
                    :size="size"
                    :min="0"
                    :max="90000000"
                    :step="100"
                    :controls="false"
                    style="width: 110px" />
                  <span v-else>{{ scope.row.priceLan != null ? scope.row.priceLan : scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('표시 순서')" width="76" align="center">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.ord"
                    :size="size"
                    :min="1"
                    :max="99"
                    :controls="false"
                    style="width: 56px" />
                </template>
              </el-table-column>
              <el-table-column :label="$t('사용')" width="60" align="center">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.useYn" active-value="Y" inactive-value="N"></el-switch>
                </template>
              </el-table-column>
              <el-table-column :label="$t('품절')" width="60" align="center">
                <template slot-scope="scope">
                  <!-- 사업장·대행 「옵션 관리」와 같은 토글이다(같은 API · 그룹 브로드캐스트) -->
                  <OptStopSellingSwitch :smenu-opt-cd="scope.row.smenuOptCd" v-model="scope.row.stopSelling" />
                </template>
              </el-table-column>
              <el-table-column :label="$t('관리')" width="128" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="checkAuthActionAccess('SmenuOptForStoreUp') && optDirty(scope.row)"
                    :size="size"
                    type="success"
                    icon="el-icon-check"
                    :title="$t('저장')"
                    @click="saveOptRow(scope.row)"></el-button>
                  <el-button
                    :size="size"
                    icon="el-icon-edit-outline"
                    :title="$t('상세')"
                    @click="openOptDialog(scope.row)"></el-button>
                  <el-button
                    v-if="checkAuthActionAccess('SmenuOptForStoreDel')"
                    :size="size"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    :title="$t('삭제')"
                    @click="delOptRow(scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 즉시 추가 -->
            <div v-if="checkAuthActionAccess('SmenuOptForStoreAdd')">
              <!-- 일반 매장: 인라인 즉시 추가 (기본명·단일 단가) -->
              <div v-if="!internationalPayYn" class="quick-add">
                <el-input
                  v-model="newOpt.smenuOptNm"
                  :size="size"
                  :placeholder="$t('새 옵션명 (Enter로 추가)')"
                  style="width: 220px"
                  @keyup.enter.native="addOptInline"></el-input>
                <el-input-number
                  v-model="newOpt.price"
                  :size="size"
                  :min="0"
                  :max="90000000"
                  :step="100"
                  :controls="false"
                  :placeholder="$t('단가')"
                  style="width: 110px; margin: 0 8px" />
                <el-button :size="size" type="primary" plain icon="el-icon-plus" @click="addOptInline">{{
                  $t('추가')
                }}</el-button>
              </div>
              <!-- 국제결제 매장: 언어별 단가 입력이 필요하므로 상세 다이얼로그로 유도 -->
              <div v-else class="quick-add">
                <span class="field-hint" style="margin-right: 10px">{{
                  $t('국제결제 매장은 언어별 단가 입력이 필요합니다. [옵션 추가]로 등록하세요.')
                }}</span>
                <el-button :size="size" type="primary" plain icon="el-icon-plus" @click="newOptDialog">{{
                  $t('옵션 추가')
                }}</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 좁은 화면 드로어 배경 (클릭 시 목록으로) -->
    <div v-if="narrow && groupMode !== 'none'" class="drawer-backdrop" @click="closeDetailNarrow"></div>

    <!-- 옵션 상세 편집 다이얼로그 -->
    <el-dialog
      :title="$t('옵션 상세')"
      :visible.sync="optDialogVisible"
      width="95%"
      :style="{ 'max-width': '760px' }"
      append-to-body>
      <el-form :model="optForm" label-width="120px" label-suffix=":" :size="size" @submit.native.prevent>
        <el-row :gutter="16">
          <el-col :md="12">
            <el-form-item :label="$t('옵션명')" :error="optFormError.smenuOptNm" required>
              <el-input v-model="optForm.smenuOptNm" maxlength="50" clearable show-word-limit>
                <el-button v-if="lans.length > 1" slot="append" @click="openDict('opt')" icon="el-icon-search">{{
                  $t('다국어 조회')
                }}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('원가')" :error="optFormError.cost" required>
              <el-input-number v-model="optForm.cost" :step="100" :min="0" :max="90000000" style="width: 200px" />
            </el-form-item>
            <el-form-item :label="$t('단가')" :error="optFormError.price" required>
              <el-input-number v-model="optForm.price" :step="100" :min="0" :max="90000000" style="width: 200px" />
            </el-form-item>
            <el-form-item :label="$t('옵션 그룹')" :error="optFormError['smenuOptTp.smenuOptTpCd']" required>
              <opt-tp-combo
                :data="groups"
                :model="optForm.smenuOptTp.smenuOptTpCd"
                @change="optForm.smenuOptTp.smenuOptTpCd = $event"></opt-tp-combo>
            </el-form-item>
            <el-form-item :label="$t('표시 순서')" :error="optFormError.ord" required>
              <el-input-number v-model="optForm.ord" :min="1" :max="99" />
            </el-form-item>
            <el-form-item :label="$t('사용 가능 여부')" required>
              <combo :data="mainVue.code.useYn" :model="optForm.useYn" @change="optForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :md="12" v-if="optForm.smenuOptInfos && optForm.smenuOptInfos.length > 0">
            <el-tabs v-model="optActiviTab">
              <el-tab-pane
                v-for="(item, index) in optForm.smenuOptInfos"
                :key="item.lanTp.id"
                :label="item.lanTp.nm"
                :name="item.lanTp.id">
                <el-form-item
                  :label="$t('옵션명')"
                  :error="optFormError['smenuOptInfos[' + index + '].smenuOptInfoNm']">
                  <el-input
                    v-model="optForm.smenuOptInfos[index].smenuOptInfoNm"
                    maxlength="50"
                    clearable
                    show-word-limit></el-input>
                </el-form-item>
                <el-form-item v-if="internationalPayYn" :label="$t('단가')">
                  <el-input-number
                    v-model="optForm.smenuOptInfos[index].price"
                    :step="100"
                    :min="0"
                    :max="90000000"
                    style="width: 180px" />
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button :size="size" icon="el-icon-check" type="primary" @click="saveOptDialog">{{ $t('저장') }}</el-button>
        <el-button :size="size" icon="el-icon-close" @click="optDialogVisible = false">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>

    <!-- 다국어 사전 -->
    <DictionaryDialog :visible="dictVisible" @close="dictVisible = false" @selectDictionary="selectDictionary" />
  </div>
</template>

<script>
import DictionaryDialog from '@/components/dictionary/DictionaryDialog.vue'
import OptStopSellingSwitch from '@/components/store/OptStopSellingSwitch.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import {
  deliveryOptionDeleteHidesNote,
  deliveryOptionGroupFanoutNote,
  deliveryOptionGroupSharedStoreNote,
  deliveryOptionSelectCountCapNote,
  deliveryOrdernOnlyItemsNote,
} from '@/utils/deliveryMenuNotes'
import { deliveryMenuPlatformName, deliveryOptionGroupLinkedOf } from '@/utils/deliveryMenuSync'
import { syncLangValue } from '@/utils/syncLangValue'
import { ALL_ROWS_PAGE_SIZE, pageRows } from '@/utils/pagedList'

const GROUP_URL = '/smenuOptTp/store'
const OPT_URL = '/smenuOpt/store'

export default {
  name: 'SMenuOptGroupForStoreView',
  mixins: [mainVueMixin],
  components: { DictionaryDialog, OptStopSellingSwitch },

  data: function () {
    var data = initData()
    // 서버가 답한 「이 그룹이 배달앱에서 어떻게 보이는가」 — 없으면 아무 말도 하지 않는다
    data.deliveryEcho = null
    data.storeLans = []
    data.lans = []
    data.internationalPayYn = false
    data.optTpCodes = []

    data.groups = []
    data.allOpts = []
    data.groupSearch = { smenuOptTpNm: '', useYn: 'Y' }
    data.loadingGroups = false
    data.loadingDetail = false

    data.groupMode = 'none' // none | view | new
    data.curGroupCd = null
    data.groupForm = this.initGroupForm()
    data.groupFormError = this.initGroupFormError()
    data.groupActiviTab = ''

    data.optRows = []
    data.optOriginals = {}
    data.newOpt = { smenuOptNm: '', price: 0 }

    data.optDialogVisible = false
    data.optForm = this.initOptForm()
    data.optFormError = this.initOptFormError()
    data.optActiviTab = ''

    data.dictVisible = false
    data.dictTarget = 'group'
    return data
  },

  computed: {
    /**
     * 최대 선택 개수의 상한 문장 — 서버가 상한을 모르면(`null`) 말하지 않는다.
     *
     * ★ **지금 값이 상한을 넘을 때만** 말한다. 넘지 않는데 띄우면 대부분의 그룹에 늘 붙어
     * 읽히지 않는 안내가 되고, 그러면 정작 넘겼을 때도 안 읽힌다.
     */
    deliveryCapNote: function () {
      var cap = this.deliveryEcho && this.deliveryEcho.maxSelectableCount
      if (cap == null) return ''
      var max = this.groupForm.maxCount || 0
      if (max === 0 || max <= cap) return ''
      return this.$t(deliveryOptionSelectCountCapNote(cap))
    },
    /**
     * ★★ **오더엔에만 있는 항목** — 그 이름은 배달앱으로 나가지 않는다
     * (`OPT-ITEM-ADD-NOT-PUSHED`). 서버가 이름을 세어 답하고 화면은 문장만 만든다.
     *
     * 관측이 없으면 서버가 빈 목록을 내리므로 아무 말도 하지 않는다 — 그때는 「배달앱에
     * 없다」가 아니라 「모른다」다.
     */
    deliveryOrdernOnlyNote: function () {
      var names = (this.deliveryEcho && this.deliveryEcho.ordernOnlyItems) || []
      return names.length ? this.$t(deliveryOrdernOnlyItemsNote(names)) : ''
    },
    /**
     * 옵션 항목 삭제 확인창의 배달앱 한 줄 (§16.302) — **오더엔 삭제 = 배달앱 숨김**, 그룹 반경으로 나간다
     * (그 그룹의 다른 항목도 오더엔 사용 여부대로 맞춰진다 — 문장이 그 반경을 말한다).
     *
     * 판정 재료는 이미 읽어 둔 echo 다 — 이 그룹이 배달앱에서 관측됐으면 단정하고, 매장에 링크가
     * 없으면 붙이지 않고, echo 가 없거나 관측이 없으면 「모른다」라 조건문이다. 옵션그룹 삭제(`delGroup`)
     * 에는 붙지 않는다 — 그 삭제는 숨김이 아니라 연결 해제다(§16.302 §1-3).
     */
    deliveryDeleteNote: function () {
      const note = deliveryOptionDeleteHidesNote(deliveryOptionGroupLinkedOf(this.deliveryEcho))
      return note ? this.$t(note) : ''
    },
    /** 같은 이름 그룹이 둘 이상인 플랫폼마다 한 줄 — 하나뿐이면 말할 것이 없다 */
    deliveryFanoutNotes: function () {
      var rows = (this.deliveryEcho && this.deliveryEcho.rows) || []
      var out = []
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].groupCount > 1) {
          out.push(
            this.$t(deliveryOptionGroupFanoutNote(deliveryMenuPlatformName(rows[i].platform), rows[i].groupCount))
          )
        }
      }
      return out
    },
    /**
     * 다른 매장과 **함께 쓰는** 그룹이라는 사실 — 플랫폼마다 한 줄.
     * `sharedStoreCount` 가 `null`(모른다·해당 없음)이거나 0이면 말할 것이 없다.
     */
    deliverySharedStoreNotes: function () {
      var rows = (this.deliveryEcho && this.deliveryEcho.rows) || []
      var out = []
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].sharedStoreCount > 0) {
          out.push(
            this.$t(
              deliveryOptionGroupSharedStoreNote(deliveryMenuPlatformName(rows[i].platform), rows[i].sharedStoreCount)
            )
          )
        }
      }
      return out
    },
    narrow: function () {
      // <1024px: 상세를 우측 슬라이드 드로어로 전환 (반응형 마스터-디테일)
      return this.$device.tablet
    },
    // 그룹별 옵션 수 — 옵션 행의 **평면 `smenuOptTpCd`** 를 센다(목록은 표시용 프로젝션이라
    // 중첩 `smenuOptTp` 객체를 싣지 않는다)
    optCountMap: function () {
      var map = {}
      for (var i = 0, len = this.allOpts.length; i < len; i++) {
        var tpCd = this.allOpts[i].smenuOptTpCd
        if (tpCd != null) {
          map[tpCd] = (map[tpCd] || 0) + 1
        }
      }
      return map
    },
  },

  created: function () {
    this.initStore()
    this.initOptTpCodes()
    this.reloadAll()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },

  methods: {
    // ── 초기화 헬퍼 ──
    initGroupForm: function () {
      return {
        statu: 'I',
        smenuOptTpCd: 0,
        smenuOptTpNm: '',
        smenuOptTpInfos: [],
        optTp: { cd: null, nm: '' },
        minCount: 0,
        maxCount: 0,
        ord: 1,
        useYn: 'Y',
        smenuOptTpDesc: '',
        masterOptTpCd: null,
      }
    },
    initGroupFormError: function () {
      return { smenuOptTpNm: '', 'optTp.cd': '', ord: '', useYn: '' }
    },
    initOptForm: function () {
      return {
        statu: 'I',
        smenuOptCd: 0,
        smenuOptNm: '',
        cost: 0,
        price: 0,
        smenuOptInfos: [],
        smenuOptTp: { smenuOptTpCd: null, smenuOptTpNm: '' },
        ord: 1,
        useYn: 'Y',
        smenuOptDesc: '',
      }
    },
    initOptFormError: function () {
      return { smenuOptNm: '', cost: '', price: '', 'smenuOptTp.smenuOptTpCd': '', ord: '' }
    },

    // ── 매장/코드 로딩 ──
    initStore: function () {
      this.mainVue.$axios.search(
        '/store/getStore',
        null,
        function (result) {
          this.storeLans = result.lans || []
          this.internationalPayYn = result.internationalPayYn
          this.lans = [result.defaultLan]
          for (var i = 0, len = this.storeLans.length; i < len; i++) {
            this.lans.push(this.storeLans[i])
          }
        }.bind(this)
      )
    },
    initOptTpCodes: function () {
      this.mainVue.$axios.search(
        '/code/getCode/OPT_TP',
        null,
        function (result) {
          this.optTpCodes = result
        }.bind(this)
      )
    },

    // ── 목록 로딩 ──
    reloadAll: function (selectCd) {
      // 옵션 먼저 로드(옵션 수 계산) → 그룹 로드.
      //
      // 이 화면은 그룹마다 「그 그룹의 옵션 전부」를 늘어놓는 마스터-디테일이라 페이지 UI 가 없다.
      // 한 장만 받으면 51번째 옵션부터 그룹에서 통째로 사라지고 개수 칸도 함께 틀린다 —
      // 오류가 아니라 **없는 옵션**으로 보인다. 그래서 전량으로 묻는다([ALL_ROWS_PAGE_SIZE]).
      this.mainVue.$axios.search(
        OPT_URL,
        { smenuOptNm: '', useYn: '', pageSize: ALL_ROWS_PAGE_SIZE },
        function (optResult) {
          this.allOpts = pageRows(optResult)
          this.loadGroups(selectCd)
        }.bind(this),
        false
      )
    },
    loadGroups: function (selectCd) {
      this.loadingGroups = true
      this.mainVue.$axios.search(
        GROUP_URL,
        this.groupSearch,
        function (result) {
          this.groups = result || []
          this.loadingGroups = false

          if (selectCd != null) {
            var found = this.groups.filter(function (g) {
              return g.smenuOptTpCd === selectCd
            })
            if (found.length) {
              this.selectGroup(found[0].smenuOptTpCd)
              return
            }
          }
          // 현재 선택 그룹이 목록에서 사라졌으면 상세 닫기
          if (this.groupMode === 'view' && this.curGroupCd != null) {
            var still = this.groups.filter(
              function (g) {
                return g.smenuOptTpCd === this.curGroupCd
              }.bind(this)
            )
            if (!still.length) this.clearDetail()
            else this.selectGroup(this.curGroupCd)
          }
        }.bind(this),
        false
      )
    },

    // ── 그룹 선택/표시 ──
    onGroupRowClick: function (row) {
      if (row) this.selectGroup(row.smenuOptTpCd)
    },
    selectGroup: function (cd) {
      var g = this.groups.filter(function (x) {
        return x.smenuOptTpCd === cd
      })[0]
      if (!g) return

      this.curGroupCd = cd
      this.groupMode = 'view'
      this.groupForm = this.buildGroupForm(g)
      this.groupFormError = this.initGroupFormError()
      this.buildOptRows(cd)
      this.loadDeliveryEcho(cd)
    },
    /**
     * ★★ **배달앱 형상은 서버가 답한다** (OPTION-NAME-FANOUT-NOTICE ·
     * OPTION-SELECT-COUNT-UNPUSHABLE). 관측·capability 의 사본을 화면에 만들지 않는다(§16.214).
     *
     * **실패해도 조용히 넘긴다** — 이 화면의 본업은 옵션 편집이고, 배달 연동이 없는 매장이
     * 대다수다(리얼 1,219곳 중 링크가 있는 곳 9곳). 그 매장에서 오류를 띄우면 존재하지 않는
     * 문제를 보게 된다.
     */
    loadDeliveryEcho: function (cd) {
      this.deliveryEcho = null
      if (!cd) return
      this.$axios
        .get('/api/delivery-menu/option-groups/' + cd + '/echo')
        .then(
          function (res) {
            // 응답이 늦게 와도 **지금 보고 있는 그룹**의 것만 반영한다
            if (this.curGroupCd === cd) this.deliveryEcho = (res && res.data) || null
          }.bind(this)
        )
        .catch(function () {})
    },
    buildGroupForm: function (g) {
      var form = {
        statu: 'U',
        smenuOptTpCd: g.smenuOptTpCd,
        smenuOptTpNm: g.smenuOptTpNm,
        smenuOptTpInfos: [],
        optTp: g.optTp ? util.copyObj(g.optTp) : { cd: null, nm: '' },
        minCount: g.minCount != null ? g.minCount : 0,
        maxCount: g.maxCount != null ? g.maxCount : 0,
        ord: g.ord,
        useYn: g.useYn,
        smenuOptTpDesc: g.smenuOptTpDesc || '',
        masterOptTpCd: g.masterOptTpCd || null,
      }
      form.smenuOptTpInfos = this.rebuildInfos(g.smenuOptTpInfos, 'smenuOptTpInfoNm')
      if (form.smenuOptTpInfos.length) this.groupActiviTab = form.smenuOptTpInfos[0].lanTp.id
      return form
    },
    // storeLans 기준으로 다국어 배열 재구성 (기존값 매핑)
    rebuildInfos: function (existing, nmKey, withPrice) {
      var out = []
      var src = existing || []
      for (var i = 0, len = this.storeLans.length; i < len; i++) {
        var nm = ''
        var price = 0
        for (var k = 0, klen = src.length; k < klen; k++) {
          if (src[k].lanTp && src[k].lanTp.id === this.storeLans[i].id) {
            nm = src[k][nmKey] || ''
            price = src[k].price || 0
          }
        }
        var row = { lanTp: this.storeLans[i] }
        row[nmKey] = nm
        if (withPrice) row.price = price
        out.push(row)
      }
      return out
    },
    buildOptRows: function (cd) {
      var rows = []
      var originals = {}
      for (var i = 0, len = this.allOpts.length; i < len; i++) {
        var o = this.allOpts[i]
        if (o.smenuOptTpCd === cd) {
          var row = util.copyObj(o)
          row.useYn = row.useYn || 'Y'
          row.stopSelling = !!row.stopSelling
          rows.push(row)
          originals[o.smenuOptCd] = {
            smenuOptNm: o.smenuOptNm,
            price: o.price,
            ord: o.ord,
            useYn: o.useYn || 'Y',
          }
        }
      }
      rows.sort(function (a, b) {
        return (a.ord || 0) - (b.ord || 0)
      })
      this.optRows = rows
      this.optOriginals = originals
      this.newOpt = { smenuOptNm: '', price: 0 }
    },
    clearDetail: function () {
      this.groupMode = 'none'
      this.curGroupCd = null
      this.optRows = []
      this.optOriginals = {}
    },
    // 좁은 화면 드로어 닫기 = 선택 해제(목록으로)
    closeDetailNarrow: function () {
      if (this.$refs.groupTable) this.$refs.groupTable.setCurrentRow(null)
      this.clearDetail()
    },

    // ── 그룹 신규/저장/삭제 ──
    newGroup: function () {
      if (this.$refs.groupTable) this.$refs.groupTable.setCurrentRow(null)
      this.groupMode = 'new'
      this.curGroupCd = null
      this.groupForm = this.initGroupForm()
      this.groupFormError = this.initGroupFormError()
      this.groupForm.smenuOptTpInfos = this.rebuildInfos([], 'smenuOptTpInfoNm')
      if (this.groupForm.smenuOptTpInfos.length) this.groupActiviTab = this.groupForm.smenuOptTpInfos[0].lanTp.id
      this.groupForm.optTp = this.optTpCodes.length > 0 ? util.copyObj(this.optTpCodes[0]) : { cd: null, nm: '' }
      // 순서 = 마지막 + 1
      var maxOrd = 0
      for (var i = 0, len = this.groups.length; i < len; i++) {
        if (this.groups[i].ord > maxOrd) maxOrd = this.groups[i].ord
      }
      this.groupForm.ord = maxOrd + 1
    },
    saveGroup: function () {
      this.groupFormError = this.initGroupFormError()
      for (var i = 0, len = this.groupForm.smenuOptTpInfos.length; i < len; i++) {
        // 동적 에러 키를 반응형으로 등록($set) — 서버 필드에러 머지(Vue.set) 시 인라인 :error 갱신 보장
        this.$set(this.groupFormError, 'smenuOptTpInfos[' + i + '].smenuOptTpInfoNm', '')
      }

      // 선택 수량 교차 검증: 최대>0 인데 최소>최대면 충족 불가능한 규칙 → 저장 차단
      var minC = this.groupForm.minCount || 0
      var maxC = this.groupForm.maxCount || 0
      if (maxC > 0 && minC > maxC) {
        this.mainVue.$message({
          type: 'warning',
          message: this.$t('최소 선택 수량은 최대 선택 수량보다 클 수 없습니다.'),
        })
        return
      }

      if ('I' === this.groupForm.statu) {
        var existingCds = this.groups.map(function (g) {
          return g.smenuOptTpCd
        })
        this.mainVue.$axios.add(
          GROUP_URL,
          this.groupForm,
          this.groupFormError,
          function () {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            // 새로 생긴 그룹 선택
            this.mainVue.$axios.search(
              GROUP_URL,
              this.groupSearch,
              function (result) {
                this.groups = result || []
                var fresh = this.groups.filter(function (g) {
                  return existingCds.indexOf(g.smenuOptTpCd) === -1
                })
                if (fresh.length) this.selectGroup(fresh[0].smenuOptTpCd)
                else this.clearDetail()
              }.bind(this),
              false
            )
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          GROUP_URL + '/' + this.groupForm.smenuOptTpCd,
          this.groupForm,
          this.groupFormError,
          function () {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.reloadAll(this.groupForm.smenuOptTpCd)
          }.bind(this),
          true
        )
      }
    },
    delGroup: function () {
      var cnt = this.optRows.length
      this.mainVue
        .$confirm(
          cnt > 0
            ? this.$t('옵션 그룹을 삭제하시겠습니까? 소속 옵션 {n}개는 유지됩니다.').replace('{n}', cnt)
            : this.$t('옵션 그룹을 삭제하시겠습니까?'),
          this.mainVue.appMsg.systemAlterTitle,
          { confirmButtonText: this.$t('삭제'), cancelButtonText: this.$t('취소'), type: 'warning' }
        )
        .then(
          function () {
            this.mainVue.$axios.del(
              GROUP_URL + '/' + this.groupForm.smenuOptTpCd,
              function () {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.clearDetail()
                this.reloadAll()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(function () {})
    },

    // ── 옵션 즉시 추가 ──
    addOptInline: function () {
      var nm = (this.newOpt.smenuOptNm || '').trim()
      if (!nm) return

      var maxOrd = 0
      for (var i = 0, len = this.optRows.length; i < len; i++) {
        if (this.optRows[i].ord > maxOrd) maxOrd = this.optRows[i].ord
      }

      var price = this.newOpt.price || 0
      // 즉시 추가는 기본명만 받으므로 전 언어 옵션명을 기본명으로 채운다(다국어 이름 필수 — 상세에서 언어별 수정)
      var infos = this.rebuildInfos([], 'smenuOptInfoNm', true)
      // ★ **이 규칙의 소유자는 syncLangValue 하나다** (규약 §16.230). 이 자리는 일곱 번째 사본이었다 —
      // 같은 파일의 다른 두 저장 경로가 이미 그 유틸을 쓰는데 여기만 인덱스 루프로 남아 있었다.
      // 이름 채우기도 같은 술어를 지난다(필드만 다르다).
      syncLangValue(infos, 'smenuOptInfoNm', nm)
      if (!this.internationalPayYn) syncLangValue(infos, 'price', price)

      var body = {
        smenuOptNm: nm,
        cost: 0,
        price: price,
        smenuOptTp: { smenuOptTpCd: this.curGroupCd },
        smenuOptInfos: infos,
        ord: maxOrd + 1,
        useYn: 'Y',
        smenuOptDesc: '',
      }

      this.mainVue.$axios.add(
        OPT_URL,
        body,
        {},
        function () {
          this.mainVue.$message({ type: 'success', message: this.$t('옵션 추가 성공') })
          this.newOpt = { smenuOptNm: '', price: 0 }
          this.reloadAll(this.curGroupCd)
        }.bind(this),
        true
      )
    },

    // ── 옵션 인라인 저장 ──
    optDirty: function (row) {
      var o = this.optOriginals[row.smenuOptCd]
      if (!o) return true
      return o.smenuOptNm !== row.smenuOptNm || o.price !== row.price || o.ord !== row.ord || o.useYn !== row.useYn
    },
    /**
     * 인라인 저장 — **본문의 원본은 상세 GET 한 곳**이다.
     *
     * 종전에는 목록 행을 그대로 복사해 보냈다. 그 행이 엔티티였을 때는 맞는 말이었지만, 목록이
     * 표시용 프로젝션이 된 뒤로는 다국어 행(`smenuOptInfos`)·그룹 객체·원가 같은 칸이 행에 없다 —
     * 그대로 보내면 **화면에서 건드리지도 않은 값이 저장 때 지워진다.** 표에 그려진 것과 엔티티가
     * 가진 것을 같은 것으로 보지 않는다는 규칙을 여기 한 곳에서 지킨다(`up()` 계열과 같은 규칙).
     *
     * 사람이 이 표에서 고칠 수 있는 칸은 네 개(이름·단가·순번·사용)이고, 그 넷만 상세 위에 덮는다.
     */
    saveOptRow: function (row) {
      this.mainVue.$axios.get(
        OPT_URL + '/' + row.smenuOptCd,
        function (detail) {
          var body = util.copyObj(detail)

          body.smenuOptNm = row.smenuOptNm
          body.price = row.price
          body.ord = row.ord
          body.useYn = row.useYn

          if (!this.internationalPayYn) syncLangValue(body.smenuOptInfos, 'price', body.price)

          this.putOptRow(row, body)
        }.bind(this),
        true
      )
    },
    /** [saveOptRow] 의 저장 갈래 — 성공 뒤 이 행의 기준선만 갱신해 다른 행의 미저장 편집을 지킨다 */
    putOptRow: function (row, body) {
      this.mainVue.$axios.up(
        OPT_URL + '/' + row.smenuOptCd,
        body,
        {},
        function () {
          this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
          // 전체 재조회 대신 이 행만 기준선/원본 캐시 갱신 → 다른 행의 미저장 편집(WIP) 보존
          this.optOriginals[row.smenuOptCd] = {
            smenuOptNm: row.smenuOptNm,
            price: row.price,
            ord: row.ord,
            useYn: row.useYn,
          }
          for (var i = 0, len = this.allOpts.length; i < len; i++) {
            if (this.allOpts[i].smenuOptCd === row.smenuOptCd) {
              this.allOpts[i].smenuOptNm = row.smenuOptNm
              this.allOpts[i].price = row.price
              this.allOpts[i].ord = row.ord
              this.allOpts[i].useYn = row.useYn
              break
            }
          }
        }.bind(this),
        true
      )
    },

    // ── 옵션 신규 (상세 다이얼로그) — 국제결제 매장 등 언어별 단가 입력이 필요할 때 ──
    newOptDialog: function () {
      var maxOrd = 0
      for (var i = 0, len = this.optRows.length; i < len; i++) {
        if (this.optRows[i].ord > maxOrd) maxOrd = this.optRows[i].ord
      }
      var form = this.initOptForm()
      form.statu = 'I'
      form.smenuOptTp = { smenuOptTpCd: this.curGroupCd, smenuOptTpNm: this.groupForm.smenuOptTpNm }
      form.ord = maxOrd + 1
      form.smenuOptInfos = this.rebuildInfos([], 'smenuOptInfoNm', true)
      this.optFormError = this.initOptFormError()
      for (var j = 0, jlen = this.storeLans.length; j < jlen; j++) {
        this.$set(this.optFormError, 'smenuOptInfos[' + j + '].smenuOptInfoNm', '')
      }
      this.optForm = form
      if (form.smenuOptInfos.length) this.optActiviTab = form.smenuOptInfos[0].lanTp.id
      this.optDialogVisible = true
    },

    // ── 옵션 상세 다이얼로그 ──
    openOptDialog: function (row) {
      this.mainVue.$axios.get(
        OPT_URL + '/' + row.smenuOptCd,
        function (result) {
          result.statu = 'U'
          this.optFormError = this.initOptFormError()
          for (var i = 0, len = this.storeLans.length; i < len; i++) {
            this.$set(this.optFormError, 'smenuOptInfos[' + i + '].smenuOptInfoNm', '')
          }
          var infos = this.rebuildInfos(result.smenuOptInfos, 'smenuOptInfoNm', true)
          result.smenuOptInfos = infos
          if (!result.smenuOptTp) result.smenuOptTp = { smenuOptTpCd: this.curGroupCd, smenuOptTpNm: '' }
          this.optForm = result
          if (infos.length) this.optActiviTab = infos[0].lanTp.id
          this.optDialogVisible = true
        }.bind(this),
        true
      )
    },
    saveOptDialog: function () {
      var body = util.copyObj(this.optForm)
      if (!this.internationalPayYn) syncLangValue(body.smenuOptInfos, 'price', body.price)
      var isNew = 'I' === this.optForm.statu
      if (isNew && body.smenuOptInfos) {
        // 언어별 옵션명 미입력은 기본명으로 채운다(다국어 이름 필수 검증 대응 — 이후 언어별 수정)
        for (var k = 0; k < body.smenuOptInfos.length; k++) {
          if (!body.smenuOptInfos[k].smenuOptInfoNm) body.smenuOptInfos[k].smenuOptInfoNm = body.smenuOptNm
        }
      }
      var onSuccess = function () {
        this.mainVue.$message({ type: 'success', message: isNew ? this.$t('등록 성공') : this.$t('수정 성공') })
        this.optDialogVisible = false
        this.reloadAll(this.curGroupCd)
      }.bind(this)
      if (isNew) {
        this.mainVue.$axios.add(OPT_URL, body, this.optFormError, onSuccess, true)
      } else {
        this.mainVue.$axios.up(OPT_URL + '/' + this.optForm.smenuOptCd, body, this.optFormError, onSuccess, true)
      }
    },
    delOptRow: function (row) {
      this.mainVue
        .$confirm(
          [this.$t('옵션 정보를 삭제 하시겠습니까?'), this.deliveryDeleteNote].filter(Boolean).join(' '),
          this.mainVue.appMsg.systemAlterTitle,
          {
            confirmButtonText: this.$t('삭제'),
            cancelButtonText: this.$t('취소'),
            type: 'info',
          }
        )
        .then(
          function () {
            this.mainVue.$axios.del(
              OPT_URL + '/' + row.smenuOptCd,
              function () {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.reloadAll(this.curGroupCd)
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(function () {})
    },

    // ── 다국어 사전 ──
    openDict: function (target) {
      this.dictTarget = target
      this.dictVisible = true
    },
    selectDictionary: function (row) {
      var form = this.dictTarget === 'group' ? this.groupForm : this.optForm
      var nmKey = this.dictTarget === 'group' ? 'smenuOptTpNm' : 'smenuOptNm'
      var infoKey = this.dictTarget === 'group' ? 'smenuOptTpInfoNm' : 'smenuOptInfoNm'
      var infos = this.dictTarget === 'group' ? form.smenuOptTpInfos : form.smenuOptInfos

      for (var i = 0, len = this.lans.length; i < len; i++) {
        if (0 === i) {
          form[nmKey] = row[this.lans[i].id]
        } else if (infos && infos[i - 1]) {
          infos[i - 1][infoKey] = row[this.lans[i].id]
        }
      }
      this.dictVisible = false
    },

    // ── 표시 헬퍼 ──
    formatRule: function (g) {
      var min = g.minCount != null ? g.minCount : 0
      var max = g.maxCount != null ? g.maxCount : 0
      if (!min && !max) return this.$t('자유')
      if (min > 0 && (!max || max === 0)) return this.$t('필수') + ' ' + min + '+'
      if (min === 0) return this.$t('선택') + ' ~' + max
      // min>0, max>0
      return this.$t('필수') + ' ' + (min === max ? String(min) : min + '~' + max)
    },
  },
}
</script>

<style scoped>
.opt-unified .empty-card {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.opt-unified .empty-hint {
  color: #909399;
  font-size: 14px;
  text-align: center;
}
.opt-unified .empty-hint i {
  margin-right: 6px;
}
.opt-unified .detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 780px;
}
.opt-unified .detail-title b {
  margin-right: 6px;
}
.opt-unified .field-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 2px;
}
/* 배달앱 형상 고지 — 오더엔 안의 규칙이 아니라 **밖의 제약**이라 색으로 가른다 */
.opt-unified .field-hint--delivery {
  color: #e6a23c;
}
/* 상단 툴바: 검색+액션을 전체 폭 한 줄로 */
.opt-unified .opt-toolbar {
  margin-bottom: 14px;
}
.opt-unified .opt-toolbar >>> .el-form-item {
  margin-bottom: 0;
}
.opt-unified .opt-toolbar .toolbar-actions >>> .el-form-item__content {
  margin-left: 0 !important;
}
/* 그룹 폼 / 옵션 항목: 넓은 화면에서 과도하게 늘어나지 않게 읽기 좋은 폭으로 캡 */
.opt-unified .group-form {
  max-width: 540px;
}
.opt-unified .opt-section {
  max-width: 780px;
}
/* 상세 카드: 박스 자체를 콘텐츠 폭에 맞춰 캡 (박스·스크롤바가 콘텐츠를 감싸도록, 남는 공간은 바깥 여백으로) */
.opt-unified .detail-scroll {
  max-width: 840px;
}
/* 상세 카드: 헤더(그룹 저장/삭제)는 고정, 본문(폼+옵션 항목)만 독립 스크롤 — 데스크톱 */
.opt-unified .detail-scroll >>> .el-card__body {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}
.opt-unified .quick-add {
  margin-top: 10px;
  padding: 10px;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 8px;
}

/* ── 옵션 항목 리스트: 인라인 편집을 가볍게 (스피너·잔상 제거, 여백) ── */
.opt-unified .opt-item-table {
  margin-top: 4px;
}
.opt-unified .opt-item-table >>> th.el-table__cell {
  background: #fafafa;
  color: #606266;
  font-weight: 600;
}
.opt-unified .opt-item-table >>> td.el-table__cell {
  padding: 9px 0;
}
/* el-input-number의 증감 컨트롤(잔상 "··") 완전 제거 + 입력 우측 정렬 */
.opt-unified .opt-item-table >>> .el-input-number .el-input-number__decrease,
.opt-unified .opt-item-table >>> .el-input-number .el-input-number__increase {
  display: none !important;
}
.opt-unified .opt-item-table >>> .el-input-number .el-input__inner {
  padding: 0 8px;
  text-align: right;
}
.opt-unified .opt-item-table >>> .el-input-number {
  line-height: normal;
}
/* 관리 아이콘 버튼 사이 여백을 살짝 */
.opt-unified .opt-item-table >>> .el-button + .el-button {
  margin-left: 6px;
}

/* ── 반응형: 좁은 화면(<1024px) 상세를 우측 슬라이드 드로어로 ── */
.opt-unified .detail-col {
  transition: box-shadow 0.2s;
}
.opt-unified .detail-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 560px;
  max-width: 92vw;
  margin: 0;
  padding: 0;
  background: #fff;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  z-index: 1201;
  transform: translateX(100%);
  transition: transform 0.25s ease;
}
.opt-unified .detail-drawer.is-open {
  transform: translateX(0);
}
.opt-unified .drawer-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1200;
}
.opt-unified .drawer-back {
  padding: 0 !important;
  margin-right: 10px;
}
.opt-unified .drill-chevron {
  color: #c0c4cc;
  font-size: 15px;
}
.opt-unified .drill-chevron.active {
  color: #409eff;
}
</style>
